export const RemoteConfigDefaultValues = {
	use_autoedit_endpoint : true,
};
